import { ClauseStatus, ContractClauseStatus } from '@/types/StatusType';

export const setRole = (value: string) => localStorage.setItem('role', value);
export const getRole = () => localStorage.getItem('role');
export const removeRole = () => localStorage.removeItem('role');

export const ProposalData = (title: string) =>
  localStorage.getItem(`counter:${title}`)?.trim();
export const SetProposalData = (title: string, value: string) =>
  localStorage.setItem(`counter:${title}`, value);
export const RemoveProposalData = (title: string) =>
  localStorage.removeItem(`counter:${title}`);

export const ClauseStatusData = (title: string): ClauseStatus => {
  const status = localStorage.getItem(`clauseStatus:${title}`)?.trim();
  return status as ClauseStatus;
};
export const SetClauseStatusData = (title: string, value: string) =>
  localStorage.setItem(`clauseStatus:${title}`, value);
export const RemoveClauseStatusData = (title: string) =>
  localStorage.removeItem(`clauseStatus:${title}`);

export const SubsetClauseStatusData = (title: string): ContractClauseStatus => {
  const status = localStorage.getItem(`subsetClauseStatus:${title}`)?.trim();
  return status as ContractClauseStatus;
};
export const SetSubsetClauseStatusData = (title: string, value: string) =>
  localStorage.setItem(`subsetClauseStatus:${title}`, value);
export const RemoveSubsetClauseStatusData = (title: string) =>
  localStorage.removeItem(`subsetClauseStatus:${title}`);
